import { ReportService } from 'services/ReportService';

const reportsService = new ReportService();

const getReports = async () => {
	const body = {
		columns_select: ["*"],
		where_select: "*",
	};
	try {
		const response = await reportsService.report.getReports(body);
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
};

const getReportsByID = async (id: number) => {
	const body = {
		columns_select: ["*"],
		where_select: { id: id },
	};

	try {
		const response = await reportsService.report.getReports(body);
		if (response.length === 0) {
			throw new Error("Report not found");
		}
		return response[0];

	} catch (error) {
		console.error(error);
		throw error;
	}
};

const gettingReportById = async (
	id: number,
	setLoading: React.Dispatch<React.SetStateAction<boolean>>,
	setQueries: React.Dispatch<React.SetStateAction<any[]>>,
	setParams: React.Dispatch<React.SetStateAction<any[]>>,
	setApis: React.Dispatch<React.SetStateAction<any[]>>,
	categories: CategoryReport[]
) => {
	setLoading(true);

	const body = {
		columns_select: ["*"],
		where_select: { id: id },
	};

	await reportsService.report.getReports(body)
		.then((response) => {
			const keys = categories.map((category) => category.name);
			const report = response.find(
				(report) => report.id === id
			);

			const queries: ReportQuery[] = [];
			const params: ReportParam[] = [];
			const apis: ReportApi[] = [];

			if (report?.json_apis) {
				const json_apis = JSON.parse(report.json_apis);

				for (const key of keys) {
					if (json_apis?.[key]?.queries) {
						for (const query of Object.keys(
							json_apis[key].queries
						)) {
							queries.push({
								category: key,
								name: query,
								string: json_apis[key].queries[query].query,
							});

							if (json_apis[key].queries[query].params) {
								for (const param of Object.keys(
									json_apis[key].queries[query].params
								)) {
									params.push({
										category: key,
										query: query,
										name: param,
										value: json_apis[key].queries[query]
											.params[param],
									});
								}
							}
						}
					}

					if (json_apis?.[key]?.apis) {
						for (const index in json_apis[key].apis) {
							const id = new Date().getTime() + index;

							apis.push({
								category: key,
								id: id.toString(),
								value: json_apis[key].apis[index].value,
							});
						}
					}
				}
			}

			setQueries(queries);
			setParams(params);
			setApis(apis);
		})
		.catch((error) => {})
		.finally(() => {
			setLoading(false);
		});
};

const gettingCategories = async (
	setLoading: React.Dispatch<React.SetStateAction<boolean>>,
	setCategories: React.Dispatch<React.SetStateAction<CategoryReportMinim[]>>
) => {
	setLoading(true);

	const body = {
		columns_select: ["*"],
		where_select: "*",
	};

	let categories: CategoryReportMinim[] = [];

	await reportsService.category.getCategorys(body)
		.then((response) => {
			categories = response.map((category) => ({
				category_id: category.id,
				name: category.name,
			}));

			setCategories(categories);
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			setLoading(false);
		});

	return categories;
};

const gettingReportByCategoryId = async (
	setLoading: React.Dispatch<React.SetStateAction<boolean>>,
	categories: CategoryReportMinim[],
	setReports: React.Dispatch<React.SetStateAction<Report[]>>,
	setItemTreeView: React.Dispatch<React.SetStateAction<CategoryWithReports[]>>
) => {
	setLoading(true);

	console.log("categories", categories);

	await reportsService.report.getReports()
		.then((reports) => {
			setReports(reports);

			const items = categories.map((category) => ({
				id: `category-${category.category_id}`,
				label: category.name,
				children: reports
					.filter(
						(report) => report.category_id === category.category_id
					)
					.map((report) => ({
						id: `report-${report.report_id}`,
						label: report.name,
					})),
			}));

			setItemTreeView(items);

			console.log("reports", reports);
			console.log("items", items);
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			setLoading(false);
		});
};

const createReport = async (
	name: string,
	status: string,
	for_employee: string,
	description: string,
	slug: string,
	category_id: number,
	properties = "{}",
	json_apis = "{}",
	template = ""
) => {

	const report = {
		object_add: {
			"name": name,
			"status": status,
			"for_employees": for_employee,
			"description": description,
			"slug": slug,
			"properties": properties,
			"json_apis": json_apis,
			"template": template,
			"category_id": category_id
		}
	}

	try {
		const response = await reportsService.report.createReport(report);
		return response;
	} catch (error) {
		console.error(error);
	}
};

const updatingReport = async (
	id: number,
	queries: ReportQuery[],
	params: ReportParam[],
	apis: ReportApi[],
	setLoading: React.Dispatch<React.SetStateAction<boolean>>,
	closing: () => void
) => {
	setLoading(true);

	const json_apis: Record<
		CategoryApi,
			{
				queries: Record<string, string>;
				apis: Record<string, string>[]
		}> = {
		TIMEKEEPER: {
			queries: {},
			apis: apis
				.filter((api) => api.category === "TIMEKEEPER")
				.map((api) => ({ value: api.value })), //[],
		},
		SCHEDULER: {
			queries: {},
			apis: apis
				.filter((api) => api.category === "SCHEDULER")
				.map((api) => ({ value: api.value })),
		},
		EMPLOYEES: {
			queries: {},
			apis: apis
				.filter((api) => api.category === "EMPLOYEES")
				.map((api) => ({ value: api.value })),
		},
		AUTH: {
			queries: {},
			apis: apis
				.filter((api) => api.category === "AUTH")
				.map((api) => ({ value: api.value })),
		},
	};

	for (const query of queries) {
		let qps = params.filter(
			(param) =>
				param.category === query.category && param.query === query.name
		);

		// @ts-ignore
		json_apis[query.category].queries[query.name] = {
			query: query.string,
			params: {},
		};

		for (const qp of qps) {
			if (qp.value === "" || qp.name === "") continue;
			// @ts-ignore
			json_apis[query.category].queries[query.name].params[qp.name] =
				qp.value;
		}
	}

	const body = {
		columns_update: {
			json_apis: JSON.stringify(json_apis),
		},
		where_update: {
			id: id,
		},
	};

	reportsService.report.updateReport(body)
		.then(() => {
			closing();
		})
		.catch((error) => {})
		.finally(() => {
			setLoading(false);
		});

	setLoading(false);
};
interface ReportUpdate{
	report_id: number,
	name: string,
	status: string,
	for_employees: string,
	description: string,
	slug: string,
	category_id: number
}
const updateReport = async (data : ReportUpdate) => {
	const report = {
		"columns_update": {
			"name": data.name,
			"status": data.status,
			"for_employees": data.for_employees,
			"description": data.description,
			"slug": data.slug,
			"category_id": data.category_id
		},
		"where_update": {
			"id": data.report_id
		}
	}
	try {
		const response = await reportsService.report.updateReport(report);
		return response;
	} catch (error) {
		console.error(error);
	}
};


/**
 * Updates the template of a report.
 * @param {Object} param - Parameters for updating the report template.
 * @param {string} param.template - The new template string.
 * @param {number} param.report_id - The ID of the report to update.
 */
interface UpdateTemplateReportParams {
	template: string;
	report_id: number;
}
const updateTemplateReport = async ({ template, report_id }: UpdateTemplateReportParams) => {
	let data = {
		columns_update: {
			template: template,
		},
		where_update: {
			id: report_id,
		},
	};
	try {
		const response = await reportsService.report.updateReport(data);
		return response;
	} catch (error) {
		console.error(error);
	}
};

const deleteReport = async (id: number) => {
	try {
		const response = await reportsService.report.deleteReport({
			where_delete: {
				id: id
			}
		});
		return response;
	} catch (error) {
		console.error(error);
	}
};

interface ExecuteReportParams {
	/** The ID of the report to execute. */
	report_id: number;
	/** If true, the report solo se emula. */
	dry_run?: boolean;
}
const executeReport = async ({ report_id, dry_run = false }: ExecuteReportParams) => {
	const response = await reportsService.report.executeReport({ report_id, dry_run });
    return response
};

export {
	getReports,
	getReportsByID,
	gettingReportById,
	createReport,
	updateReport,
	updatingReport,
	updateTemplateReport,
	deleteReport,
	executeReport,
	gettingCategories,
	gettingReportByCategoryId,
};
